import React from "react";
import CollapseSection from "../../../collapse/CollapseSection";
import { Grid2, Stack } from "@mui/material";
import TextInput from "../../../input/TextInput";
import {
  Control,
  Controller,
  FieldErrors,
  FieldValues,
  UseFormRegister,
} from "react-hook-form";
import SelectApiInput from "../../../input/SelectApiInput";
import { numeralCustom } from "../../../../../utils/helpers";
import FormNhomMon from "../../nhommon/FormNhomMon";
import FormDMDVT from "../../dmdvt/FormDMDVT";

interface IInfoSection {
  isEdit?: boolean;
  errors?: FieldErrors<any>;
  control?: Control<any, any>;
  register?: UseFormRegister<FieldValues> | undefined;
}

function InfoSection({ isEdit, errors, control, register }: IInfoSection) {
  return (
    <CollapseSection title="Thông tin sản phẩm" show>
      <Grid2 container spacing={2}>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Stack gap={2}>
            <TextInput
              readOnly={isEdit}
              label="Mã món "
              labelWidth="25%"
              placeholder="Nhập hoặc tạo tự động"
              name="ma_vt"
              register={register}
            />
            <TextInput
              required
              label="Tên món"
              labelWidth="25%"
              placeholder="Nhập tên món"
              name="ten_vt"
              register={register}
              errorMessage={errors?.ten_vt?.message as string}
            />
            <Controller
              control={control}
              name="don_vi_tinh"
              render={({ field: { value, onChange } }) => {
                return (
                  <SelectApiInput
                    required
                    labelWidth="25%"
                    label="Đơn vị tính"
                    placeholder="Chọn đơn vị tính"
                    value={value}
                    onChange={onChange}
                    apiCode="dmdvt"
                    searchFields={["ma_dvt", "ten_dvt"]}
                    getOptionLabel={(option) => option.ten_dvt}
                    checkEqual={(value, option) =>
                      value.ma_dvt === option.ma_dvt
                    }
                    errorMessage={errors?.don_vi_tinh?.message as string}
                    Form={FormDMDVT}
                  />
                );
              }}
            />
          </Stack>
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Stack gap={2}>
            <Controller
              control={control}
              name="nhom_vat_tu"
              render={({ field: { value, onChange } }) => {
                return (
                  <SelectApiInput
                    labelWidth="25%"
                    label="Nhóm món"
                    placeholder="Chọn nhóm món"
                    value={value}
                    onChange={onChange}
                    apiCode="dmnvt"
                    defaultCondition={{ la_nhom_hang_hoa: false }}
                    searchFields={["ten_nvt"]}
                    getOptionLabel={(option) => option.ten_nvt}
                    checkEqual={(value, option) => value._id === option._id}
                    Form={FormNhomMon}
                  />
                );
              }}
            />
            <Controller
              name="gia_mua"
              control={control}
              render={({ field: { value, onChange } }) => {
                return (
                  <TextInput
                    label="Giá vốn"
                    labelWidth="25%"
                    placeholder="Nhập giá vốn"
                    value={numeralCustom(value).format()}
                    endAdornment="VND"
                    onChange={(e) => {
                      const val = e.target.value;
                      onChange(numeralCustom(val).value());
                    }}
                  />
                );
              }}
            />
            <Controller
              name="gia_ban_le"
              control={control}
              render={({ field: { value, onChange } }) => {
                return (
                  <TextInput
                    label="Giá bán"
                    labelWidth="25%"
                    placeholder="Nhập giá bán"
                    value={numeralCustom(value).format()}
                    endAdornment="VND"
                    onChange={(e) => {
                      const val = e.target.value;
                      onChange(numeralCustom(val).value());
                    }}
                  />
                );
              }}
            />
          </Stack>
        </Grid2>
      </Grid2>
    </CollapseSection>
  );
}

export default InfoSection;
